export default "__VITE_ASSET__DPbifmJk__"